module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/469.5d18e7a0.png";